<template>
  <div>
    <div v-if="gridData && gridData.items && gridData.items.length">
      <table id="order-history-grid" class="b2b-grid b2b-grid--collapse mb-0 is-compact">
        <thead class="b2b-grid__header">
          <tr>
            <template v-for="(column, index) in columns">
              <th
                :key="index"
                class="b2b-grid__cell b2b-grid__head"
                :class="[column.cssClasses]"
                :qaid="`shipmentsInquiry.${column.key}Header`"
              >
                {{ column.label }}
              </th>
            </template>
          </tr>
        </thead>

        <tbody>
          <!-- Each Row -->
          <template v-for="(row, rowIndex) in paginatedData">
            <shipments-inquiry-grid-item
              :key="rowIndex"
              :base-properties="baseProperties"
              :row="row"
              :row-id="rowIndex"
              :class="[{'bg-gray-02': (rowIndex + 1) % 2 === 0}]"
            />
          </template>
        </tbody>
      </table>
      <div class="grid-x grid-margin-x mb-5 mt-2">
        <div class="cell medium-6 large-8">
          <pagination
            v-if="gridData.pageCount > 1"
            ref="pagination"
            :page-number="gridData.pageIndex"
            :page-count="gridData.pageCount"
            @page-change="pageChange"
            @prev-page="prevPage"
            @next-page="nextPage"
          ></pagination>
        </div>
      </div>
    </div>
    <pdl-callout v-else>
      <template #content>
        <span v-html="bp('searchNoResults')" />
      </template>
    </pdl-callout>
  </div>
</template>

<script>
import pagination from '../../../mixins/pagination';
import Pagination from '@/components/Pagination';
import ShipmentsInquiryGridItem from '@/components/containers/my-account/ShipmentsInquiryGridItem';
import {PdlCallout} from '@pedal/pdl-callout';

export default {
  components: {Pagination, ShipmentsInquiryGridItem, PdlCallout},
  mixins: [pagination],
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      required: false,
      default: 50,
    },

    gridData: {
      type: Object,
      default: () => {},
    },

    columns: {
      type: Array,
      default: () => [],
    },
  },

  inject: ['container'],

  data() {
    return {
      pageIndex: 0,
    };
  },

  computed: {
    listData() {
      return this.gridData.items;
    },

    headers() {
      return this.columns;
    },
  },

  provide() {
    return {
      grid: this,
      container: this.container,
    };
  },

  methods: {
    pageChange(num) {
      this.gridData.pageIndex = num;
      this.container.fetchOrders(this.gridData.type);
    },
  },
};
</script>
